export default "__VITE_ASSET__B2_uS1An__"